var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h2", { staticClass: "border-none" }, [
      _vm._v("Choose your interests and appear in more searches"),
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("div", { staticClass: "spacer-b-2 lead-text" }, [
          _vm._v("Adding interests will help get you more of the following"),
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "spacer-t-5 lead-text" }, [
          _vm._v("Select any areas that you are interested in"),
        ]),
        _vm._v(" "),
        _vm._l(_vm.interestCategories, function (categories, group) {
          return _c("div", { key: group, staticClass: "w-full" }, [
            _c("h2", [_vm._v(_vm._s(group))]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex flex-wrap" },
              _vm._l(categories, function (category, index) {
                return _c(
                  "div",
                  {
                    key: category.id,
                    staticClass: "category",
                    class: category.selected ? "category--selected" : "",
                    on: {
                      click: function ($event) {
                        return _vm.$emit(
                          "toggled",
                          category.id,
                          index,
                          group,
                          category.name
                        )
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "fa",
                      class: category.selected ? "fa-check" : "fa-plus",
                    }),
                    _vm._v(
                      "\n          " + _vm._s(category.name) + "\n        "
                    ),
                  ]
                )
              }),
              0
            ),
          ])
        }),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", [
      _c(
        "button",
        {
          staticClass: "add-button margin-y-4",
          on: {
            click: () => {
              _vm.showCustomCategories = !_vm.showCustomCategories
            },
          },
        },
        [
          _c("i", {
            staticClass: "fa",
            class: _vm.showCustomCategories ? "fa-minus" : "fa-plus",
          }),
          _vm._v(" Add other interests"),
        ]
      ),
      _vm._v(" "),
      _vm.showCustomCategories
        ? _c(
            "div",
            [
              _c("div", { staticClass: "margin-y-2 lead-text" }, [
                _vm._v(
                  "Add any other interests you have that don't appear above"
                ),
              ]),
              _vm._v(" "),
              _c("search-picker", {
                attrs: {
                  "full-width": true,
                  "with-icon": true,
                  "with-popper": true,
                  "get-data": _vm.getInterestCategories,
                  current: _vm.selectedCategories,
                  placeholder: "Search for an interest",
                },
                on: {
                  selected: (option) => {
                    _vm.$emit("selected", option)
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "list-item-content",
                      fn: function ({ option }) {
                        return [
                          option.group
                            ? _c(
                                "div",
                                { staticClass: "search-picker__subtext" },
                                [_c("span", [_vm._v(_vm._s(option.group))])]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2486597269
                ),
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex margin-t-2 flex-wrap" },
                _vm._l(_vm.customCategories, function (category, index) {
                  return _c(
                    "div",
                    {
                      key: category.id,
                      staticClass: "category category--selected",
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(category.name) + "\n          "
                      ),
                      _c("i", {
                        staticClass: "fa fa-times",
                        on: {
                          click: function ($event) {
                            return _vm.$emit(
                              "deleted",
                              category.id,
                              index,
                              category.name
                            )
                          },
                        },
                      }),
                    ]
                  )
                }),
                0
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "flex flex-row flex-wrap gray-500 w-2/3 justify-between" },
      [
        _c("div", { staticClass: "info-item" }, [
          _c(
            "div",
            { staticClass: "w-2/10 flex justify-center align-center" },
            [_c("i", { staticClass: "fa fa-user-circle" })]
          ),
          _vm._v(" Brand Ambassadorships"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-item" }, [
          _c(
            "div",
            { staticClass: "w-2/10 flex justify-center align-center" },
            [_c("i", { staticClass: "fa fa-mobile" })]
          ),
          _vm._v(" Video Shout-outs"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-item" }, [
          _c(
            "div",
            { staticClass: "w-2/10 flex justify-center align-center" },
            [_c("i", { staticClass: "fa fa-comments" })]
          ),
          _vm._v(" Social Media Campaigns"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-item" }, [
          _c(
            "div",
            { staticClass: "w-2/10 flex justify-center align-center" },
            [_c("i", { staticClass: "fa fa-camera" })]
          ),
          _vm._v(" Meet & Greets"),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }